import React from "react";
import { Modal } from "../../../components";
import { generatePdfName } from "../../../utilities/esigningUtils";

interface Props {
  isOpen: boolean
  onClose: () => void
  version: number
  documentId: number
  documentNumber: string
}

const PdfViewerModal = (props: Props) => {
  const { version, documentId, documentNumber } = props;

  const fileName = generatePdfName(documentNumber, version);

  const url = window.CoreApi.ESign.DownloadStitchedFile.absoluteUrl(documentId, fileName, true);

  return <Modal
    displayHeader={false}
    isOpen={props.isOpen}
    handleClose={props.onClose}
    width="huge"
    height={"max"}
  >
    <iframe
      width="100%"
      height="100%"
      src={url}
      style={{ border: 0 }}
    />
  </Modal>;
};

export default PdfViewerModal;